import React from 'react';
import { useTranslation } from 'react-i18next';

import BaseCheckBoxButton from './base/BaseCheckboxButton';

const RenderCheckboxButtonsGroup = ({
  data,
  selectedValues,
  onChange,
}) => {
  const { t } = useTranslation();

  return (
    <div className={'checkbox-btns'}>
      {Object.values(data)
        .map((btn, key) => (
          <BaseCheckBoxButton
            key={key}
            selected={+selectedValues[btn.query_key] || 0}
            label={t(`client_${btn.labelKey}`)}
            action={value => onChange(btn.query_key, value)}
          />
        ))}
    </div>
  );
};

export default RenderCheckboxButtonsGroup;